/* Green Gorilla Fruits — selling plan selector
 * --------------------------------------------------------------
 * Wires the Omakase Select hero plan buttons to the hidden
 * `selling_plan` input on the add-to-cart form. Submitting the
 * form is delegated to cart-drawer.js (window.ggCart.add) when
 * available; if AJAX fails, the native <form> POST takes over.
 */
(function () {
  'use strict';

  const SELECTOR = '[data-gg-plan-selector]';

  function bindSelector(form) {
    if (form.dataset.ggPlanSelectorBound === 'true') return;
    form.dataset.ggPlanSelectorBound = 'true';

    const planInput = form.querySelector('[data-gg-selling-plan]');
    const buttons = form.querySelectorAll('[data-gg-plan-id]');
    if (!planInput || buttons.length === 0) return;

    function setActive(target) {
      buttons.forEach((btn) => {
        const isActive = btn === target;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.dataset.ggPlanActive = isActive ? 'true' : 'false';
      });
      planInput.value = target.dataset.ggPlanId || '';
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(btn);
      });
    });

    // Default selection: explicit data-gg-plan-default="true", else
    // first button.
    const preferred =
      form.querySelector('[data-gg-plan-default="true"]') || buttons[0];
    if (preferred) setActive(preferred);
  }

  function bindAll() {
    document.querySelectorAll(SELECTOR).forEach(bindSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
